import React from "react";
import styled from "@emotion/styled";

/**
 * AuthContainer is a styled div component created using the @emotion/styled library.
 * It sets the height of the container to 100% of the viewport height.
 */
const AuthContainer = styled.div(() => ({
  height: "100vh",
}));

/**
 * AuthLayout is a functional React component that provides a layout specifically for authentication-related pages.
 *
 * @param {React.ReactNode} children - The child components or elements that will be rendered inside the AuthLayout.
 * @returns {React.ReactElement} A styled container wrapping the child elements.
 *
 * Usage:
 * <AuthLayout>
 *   ... (authentication-related components like login or registration forms)
 * </AuthLayout>
 */
export const AuthLayout = ({ children }) => {
  return <AuthContainer>{children}</AuthContainer>;
};

export default AuthLayout;
